import { instanceOf } from './instance-of';

export const date = instanceOf(Date);
